module.exports = __webpack_public_path__ + "static/media/3_col_8.c7f0b049.jpg";